import { Box, Button, Checkbox, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader, Paper, Typography } from "@mui/material";
import axiosClient from "../../../../../lib/axios";
import { useQuery } from "react-query";
import groupBy from "../../../../../helpers/groupBy";
import { useMemo, useState } from "react";
import LoadingApiQuery from "../../../../../components/LoadingApiQuery";
import DisplayNotFoundInfo from "../../../../../components/DisplayNotFindInfo";
import { IDataItensExpedir } from "../../../../../types/api/estoque/pesquisar-itens-para-expedir";

export default function AguardandoSeparacao({
    lojaSelecionadaId,
    handleSeparar
}: AguardandoSeparacaoProps) {

    const [checked, setChecked] = useState<string[]>([]);

    //queries e mutations
    const { data, isFetching } = useQuery({
        queryKey: ['pesquisar-itens-para-expedir', lojaSelecionadaId],
        queryFn: () => axiosClient.get("/estoque/pesquisar-itens-para-expedir", {
            params: {
                loja_id: lojaSelecionadaId
            }
        }),
        keepPreviousData: false,
        refetchOnWindowFocus: true,
        cacheTime: 0,
        retry: false,
        enabled: Boolean(lojaSelecionadaId)
    });
    const items: IDataItensExpedir[] = useMemo(() => data?.data || [], [data]);
    //

    //funções manipuladoras
    const handleToggle = (value: string) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };
    //

    //valores importantes
    const grouped: IGrouped = useMemo(() => {
        if (!items) return null
        return groupBy(items, (i) => i.destinatario);
    }, [items])
    //

    return (
        <Box p={2} component={Paper}>
            <Typography variant='h6'>Aguardando separação</Typography>

            {
                isFetching && <LoadingApiQuery />
            }

            {
                (grouped && !isFetching) &&
                <>
                    {
                        Object.keys(grouped).length === 0 &&
                        <DisplayNotFoundInfo
                            label="Nenhum item foi encontrado para listar"
                            variant="caption"
                            justifyContent="flex-start"
                        />
                    }

                    <List
                        subheader={<li />}
                        sx={{
                            my: 1,
                            width: '100%',
                            bgcolor: 'background.paper',
                            position: 'relative',
                            overflow: 'auto',
                            maxHeight: 380,
                            '& ul': { padding: 0 },
                        }}
                    >
                        {
                            Object.keys(grouped).map((key) => {
                                let items = grouped[key];
                                return (
                                    <li key={`section-${key}`}>
                                        <ul>
                                            <ListSubheader>Destino: {key}</ListSubheader>
                                            {items.map((expedicao: any, i: any) => {
                                                const labelId = `checkbox-list-label-${i}`;
                                                return (
                                                    <ListItem key={`item-${key}-${i}`}>
                                                        <ListItemButton role={undefined} onClick={handleToggle(expedicao.pedido)} dense>
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    checked={checked.indexOf(expedicao.pedido) !== -1}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    slotProps={{ input: { 'aria-labelledby': labelId } }}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                id={labelId}
                                                                primary={`Pedido #` + expedicao.pedido}
                                                                secondary={expedicao.criado_em}
                                                            />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )
                                            }

                                            )}
                                        </ul>
                                    </li>
                                )
                            })

                        }

                    </List>

                    <Button
                        disabled={checked.length === 0}
                        fullWidth
                        variant="contained"
                        onClick={() => {
                            handleSeparar(items.filter((i: any) => checked.includes(i.pedido)))
                        }}
                    >
                        Separar
                    </Button>
                </>
            }

        </Box>
    )
}

interface AguardandoSeparacaoProps {
    lojaSelecionadaId: number
    handleSeparar: (itens: IDataItensExpedir[]) => void
}

interface IGrouped {
    [key: string]: IDataItensExpedir[]
}